module.exports = __webpack_public_path__ + "static/media/icon_user_VIP.fb3eccab.png";